import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import ConditionsTreatments from '../../components/ConditionsTreatments/ConditionsTreatments';
import CtafromSection from '../../components/CtafromSection/CtafromSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo-2.svg'


const ConditionsPage = () => {
    return (
        <Fragment>
            <Helmet>
                <title>Conditions We Treat | Stem Cell Therapy for Orthopedic, Neurological & Autoimmune Conditions</title>
                <meta name="description" content="Advanced regenerative treatments for orthopedic conditions (knee/hip/shoulder arthritis, sports injuries), neurological disorders (neuropathy, chronic pain), autoimmune diseases (rheumatoid arthritis, MS, lupus), and anti-aging wellness." />
                <meta name="keywords" content="knee arthritis treatment Florida, hip pain stem cells, peripheral neuropathy treatment, rheumatoid arthritis regenerative medicine, sports injury PRP, chronic pain management, autoimmune stem cell therapy, anti-aging wellness" />
                <meta property="og:title" content="Conditions We Treat - Comprehensive Regenerative Medicine" />
                <meta property="og:description" content="Treating orthopedic, neurological, autoimmune conditions and wellness optimization with advanced stem cell therapy and regenerative medicine." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://ampedtherapeutics.com/conditions" />
                <link rel="canonical" href="https://ampedtherapeutics.com/conditions" />
            </Helmet>
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <PageTitle pageTitle={'Conditions We Treat'} pagesub={'Conditions'} />
            <ConditionsTreatments />
            <CtafromSection hclass={'ctafrom_section'} />
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />
        </Fragment>
    )
};

export default ConditionsPage;